/**
 * Referral reward types — mirrors backend REFERRER_REWARD_TYPE_* constants.
 */
export var REFERRER_REWARD_TYPE = {
  CACHE: 1,
  ROAD_SERVICE: 2,
  SHIPPING: 3,
  REGISTRATION: 4,
  CASH_CAR_CONDITION_ONLY: 5,
  BUNDLE: 6,
  WARRANTY: 7
};